module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root-container"
  }, [_c('el-row', {
    staticClass: "box-header"
  }, [_c('el-col', {
    staticClass: "chart-title-text-container",
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "chart-title-text"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "placement": "right"
    }
  }, [_c('i', {
    staticClass: "icon-question-circle"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n          活跃周期：设备首次上线到最后一次上线的时间跨度。"), _c('br'), _vm._v("各个活跃周期数据不重叠，比如：“一周以上”表示“一周以上，一个月以下”，以此类推。\n        ")])])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "chart-subtitle-text-container",
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "chart-subtitle-text"
  }, [_vm._v("\n        截止" + _vm._s(_vm.endAt) + "\n      ")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "140px",
      "margin-left": "10px"
    },
    attrs: {
      "type": "date",
      "range-separator": "至",
      "size": "mini",
      "editable": false,
      "clearable": true,
      "format": "yyyy/M/d",
      "value-format": "yyyy/M/d",
      "placeholder": "选择截止日期",
      "picker-options": _vm.pickerOptions
    },
    on: {
      "change": _vm.changeEndAt
    },
    model: {
      value: (_vm.endAt),
      callback: function($$v) {
        _vm.endAt = $$v
      },
      expression: "endAt"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "box-main",
    staticStyle: {
      "height": "400px"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "chart_ref",
    staticClass: "box-chart",
    attrs: {
      "element-loading-spinner": "el-icon-loading"
    }
  })]), _vm._v(" "), _c('el-row', {
    staticClass: "box-header",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('el-col', {
    staticClass: "chart-title-text-container",
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "chart-title-text"
  }, [_vm._v("活跃周期分布明细")])]), _vm._v(" "), _c('el-col', {
    staticClass: "chart-subtitle-text-container",
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "chart-subtitle-text"
  }, [_vm._v("\n        截止" + _vm._s(_vm.endAt) + "\n      ")])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "box-main",
    staticStyle: {
      "height": "400px"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.detail,
      "max-height": "400",
      "element-loading-spinner": "el-icon-loading"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "width": "50",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.$index + 1) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "active_period",
      "label": "活跃周期",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "device_count",
      "label": "设备数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "device_percent",
      "label": "设备占比",
      "align": "center"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5616f95f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/AnalyzeActivePeriodManagement.vue
// module id = 1272
// module chunks = 1